import { getEntityById } from './selectorUtils';

import {
  processChoices,
  getDefaultValue,
} from 'services/choiceProducerService';

export function blockSelector(state, blockId) {
  return getEntityById(state, 'questionBlocks', blockId);
}

export function currentQuestionBlockSelector(state) {
  const { survey: { currentQuestionBlockId } } = state;
  if (currentQuestionBlockId === null) {
    return null;
  }
  return blockSelector(state, currentQuestionBlockId);
}

export function questionSelector(state, id, schemaName = 'questions') {
  let question = getEntityById(state, schemaName, id);

  switch (schemaName) {
    case 'matrixQuestions':
      return {
        ...question,
        columns: {
          questions: question.columns.questions.map(id =>
            questionSelector(state, id)
          ),
        },
      };
    default:
      return {
        ...question,
        choices: processChoices(question, state),
        defaultValue: getDefaultValue(question),
      };
  }
}

export function questionsForBlockSelector(state, block) {
  if (block) {
    return block.questions.map(stub =>
      questionSelector(state, stub.id, stub.schema)
    );
  } else {
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/selectors/surveySelectors.js